var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled, { css } from "styled-components";
import Card from "@irati/ui/src/Layout/Card";
import Icon, { IconTypes } from "@irati/ui/src/Icon";
import { Input } from "@irati/ui/src/Typography";
import { FormattedMessage } from "@irati/utils/lang";
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  border: 1px solid ", ";\n  border-radius: ", ";\n  padding: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  border: 1px solid ", ";\n  border-radius: ", ";\n  padding: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.utility.subdued;
}, function (_a) {
    var theme = _a.theme;
    return theme.border.radius;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.two;
});
var StyledCard = styled(Card)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  max-width: 500px;\n  margin: 0 auto;\n  ", "\n"], ["\n  max-width: 500px;\n  margin: 0 auto;\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    box-shadow: ", ";\n    ", "\n    ", "\n  "], ["\n    box-shadow: ", ";\n    ",
        "\n    ",
        "\n  "])), theme.shadows.low, theme.mediaQueries.minWidthMedia.tablet(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      margin-top: 60px;\n    "], ["\n      margin-top: 60px;\n    "]))), theme.mediaQueries.minWidthMedia.desktop(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      margin-top: 30px;\n    "], ["\n      margin-top: 30px;\n    "]))));
});
var BannerLink = /** @class */ (function (_super) {
    __extends(BannerLink, _super);
    function BannerLink() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BannerLink.prototype.render = function () {
        return (React.createElement(StyledCard, null,
            React.createElement(Wrapper, null,
                React.createElement(Icon, { icon: IconTypes.search, marginRight: 2 }),
                React.createElement(Input, null,
                    React.createElement(FormattedMessage, { id: "recognition.banner.link.text" })))));
    };
    return BannerLink;
}(PureComponent));
export default BannerLink;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
